"use strict";

var _asyncToGenerator = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
var _toConsumableArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var mobx_state_tree_1 = require("mobx-state-tree");
var RendererType_1 = __importDefault(require("./pluggableElementTypes/renderers/RendererType"));
var AdapterType_1 = __importDefault(require("./pluggableElementTypes/AdapterType"));
var TrackType_1 = __importDefault(require("./pluggableElementTypes/TrackType"));
var DisplayType_1 = __importDefault(require("./pluggableElementTypes/DisplayType"));
var ViewType_1 = __importDefault(require("./pluggableElementTypes/ViewType"));
var WidgetType_1 = __importDefault(require("./pluggableElementTypes/WidgetType"));
var ConnectionType_1 = __importDefault(require("./pluggableElementTypes/ConnectionType"));
var RpcMethodType_1 = __importDefault(require("./pluggableElementTypes/RpcMethodType"));
var InternetAccountType_1 = __importDefault(require("./pluggableElementTypes/InternetAccountType"));
var TextSearchAdapterType_1 = __importDefault(require("./pluggableElementTypes/TextSearchAdapterType"));
var AddTrackWorkflowType_1 = __importDefault(require("./pluggableElementTypes/AddTrackWorkflowType"));
var configuration_1 = require("./configuration");
var ReExports_1 = __importDefault(require("./ReExports"));
var CorePlugin_1 = __importDefault(require("./CorePlugin"));
var jexl_1 = __importDefault(require("./util/jexl"));
/** little helper class that keeps groups of callbacks that are
then run in a specified order by group */
var PhasedScheduler = /*#__PURE__*/function () {
  function PhasedScheduler() {
    _classCallCheck(this, PhasedScheduler);
    this.phaseCallbacks = new Map();
    this.phaseOrder = [];
    for (var _len = arguments.length, phaseOrder = new Array(_len), _key = 0; _key < _len; _key++) {
      phaseOrder[_key] = arguments[_key];
    }
    this.phaseOrder = phaseOrder;
  }
  _createClass(PhasedScheduler, [{
    key: "add",
    value: function add(phase, callback) {
      if (!this.phaseOrder.includes(phase)) {
        throw new Error("unknown phase ".concat(phase));
      }
      var phaseCallbacks = this.phaseCallbacks.get(phase);
      if (!phaseCallbacks) {
        phaseCallbacks = [];
        this.phaseCallbacks.set(phase, phaseCallbacks);
      }
      phaseCallbacks.push(callback);
    }
  }, {
    key: "run",
    value: function run() {
      var _this = this;
      this.phaseOrder.forEach(function (phaseName) {
        var _a;
        (_a = _this.phaseCallbacks.get(phaseName)) === null || _a === void 0 ? void 0 : _a.forEach(function (callback) {
          return callback();
        });
      });
    }
  }]);
  return PhasedScheduler;
}();
/** internal class that holds the info for a certain element type */
var TypeRecord = /*#__PURE__*/function () {
  function TypeRecord(typeName, baseClass) {
    _classCallCheck(this, TypeRecord);
    this.typeName = typeName;
    this.baseClass = baseClass;
    this.registeredTypes = {};
  }
  _createClass(TypeRecord, [{
    key: "add",
    value: function add(name, t) {
      this.registeredTypes[name] = t;
    }
  }, {
    key: "has",
    value: function has(name) {
      return name in this.registeredTypes;
    }
  }, {
    key: "get",
    value: function get(name) {
      if (!this.has(name)) {
        throw new Error("".concat(this.typeName, " '").concat(name, "' not found, perhaps its plugin is not loaded or its plugin has not added it."));
      }
      return this.registeredTypes[name];
    }
  }, {
    key: "all",
    value: function all() {
      return Object.values(this.registeredTypes);
    }
  }]);
  return TypeRecord;
}();
var PluginManager = /*#__PURE__*/function () {
  function PluginManager() {
    var _this2 = this;
    var initialPlugins = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    _classCallCheck(this, PluginManager);
    this.plugins = [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.jexl = (0, jexl_1.default)();
    this.pluginMetadata = {};
    this.runtimePluginDefinitions = [];
    this.elementCreationSchedule = new PhasedScheduler('renderer', 'adapter', 'text search adapter', 'display', 'track', 'connection', 'view', 'widget', 'rpc method', 'internet account', 'add track workflow');
    this.rendererTypes = new TypeRecord('RendererType', RendererType_1.default);
    this.adapterTypes = new TypeRecord('AdapterType', AdapterType_1.default);
    this.textSearchAdapterTypes = new TypeRecord('TextSearchAdapterType', TextSearchAdapterType_1.default);
    this.trackTypes = new TypeRecord('TrackType', TrackType_1.default);
    this.displayTypes = new TypeRecord('DisplayType', DisplayType_1.default);
    this.connectionTypes = new TypeRecord('ConnectionType', ConnectionType_1.default);
    this.viewTypes = new TypeRecord('ViewType', ViewType_1.default);
    this.widgetTypes = new TypeRecord('WidgetType', WidgetType_1.default);
    this.rpcMethods = new TypeRecord('RpcMethodType', RpcMethodType_1.default);
    this.addTrackWidgets = new TypeRecord('AddTrackWorkflow', AddTrackWorkflowType_1.default);
    this.internetAccountTypes = new TypeRecord('InternetAccountType', InternetAccountType_1.default);
    this.configured = false;
    this.extensionPoints = new Map();
    this.jbrequireCache = new Map();
    this.lib = ReExports_1.default;
    this.load = function (lib) {
      if (!_this2.jbrequireCache.has(lib)) {
        _this2.jbrequireCache.set(lib, lib(_this2));
      }
      return _this2.jbrequireCache.get(lib);
    };
    /**
     * Get the re-exported version of the given package name.
     * Throws an error if the package is not re-exported by the plugin manager.
     *
     * @returns the library's default export
     */
    this.jbrequire = function (lib) {
      if (typeof lib === 'string') {
        var pack = _this2.lib[lib];
        if (!pack) {
          throw new TypeError("No jbrequire re-export defined for package '".concat(lib, "'. If this package must be shared between plugins, add it to ReExports.js. If it does not need to be shared, just import it normally."));
        }
        return pack;
      }
      if (typeof lib === 'function') {
        return _this2.load(lib);
      }
      if (lib.default) {
        return _this2.jbrequire(lib.default);
      }
      throw new TypeError('lib passed to jbrequire must be either a string or a function');
    };
    // add the core plugin
    this.addPlugin({
      plugin: new CorePlugin_1.default(),
      metadata: {
        isCore: true
      }
    });
    // add all the initial plugins
    initialPlugins.forEach(function (plugin) {
      _this2.addPlugin(plugin);
    });
  }
  _createClass(PluginManager, [{
    key: "pluginConfigurationSchemas",
    value: function pluginConfigurationSchemas() {
      var configurationSchemas = {};
      this.plugins.forEach(function (plugin) {
        if (plugin.configurationSchema) {
          configurationSchemas[plugin.name] = plugin.configurationSchema;
        }
      });
      return configurationSchemas;
    }
  }, {
    key: "addPlugin",
    value: function addPlugin(load) {
      if (this.configured) {
        throw new Error('JBrowse already configured, cannot add plugins');
      }
      // check for availability of 'install' and 'configure' as a proxy for being
      // an 'instanceof Plugin'
      var _ref = 'install' in load && 'configure' in load ? [load, {}] : [load.plugin, load.metadata],
        _ref2 = _slicedToArray(_ref, 2),
        plugin = _ref2[0],
        _ref2$ = _ref2[1],
        metadata = _ref2$ === void 0 ? {} : _ref2$;
      if (this.plugins.includes(plugin)) {
        throw new Error('plugin already installed');
      }
      this.pluginMetadata[plugin.name] = metadata;
      if ('definition' in load) {
        // @ts-ignore
        this.runtimePluginDefinitions.push(load.definition);
      }
      plugin.install(this);
      this.plugins.push(plugin);
      return this;
    }
  }, {
    key: "getPlugin",
    value: function getPlugin(name) {
      return this.plugins.find(function (p) {
        return p.name === name;
      });
    }
  }, {
    key: "hasPlugin",
    value: function hasPlugin(name) {
      return this.getPlugin(name) !== undefined;
    }
  }, {
    key: "createPluggableElements",
    value: function createPluggableElements() {
      // run the creation callbacks for each element type in order.
      // see elementCreationSchedule above for the creation order
      if (this.elementCreationSchedule) {
        this.elementCreationSchedule.run();
        delete this.elementCreationSchedule;
      }
      return this;
    }
  }, {
    key: "setRootModel",
    value: function setRootModel(rootModel) {
      this.rootModel = rootModel;
    }
  }, {
    key: "configure",
    value: function configure() {
      var _this3 = this;
      if (this.configured) {
        throw new Error('already configured');
      }
      this.plugins.forEach(function (plugin) {
        return plugin.configure(_this3);
      });
      this.configured = true;
      return this;
    }
  }, {
    key: "getElementTypeRecord",
    value: function getElementTypeRecord(groupName) {
      switch (groupName) {
        case 'adapter':
          return this.adapterTypes;
        case 'text search adapter':
          return this.textSearchAdapterTypes;
        case 'connection':
          return this.connectionTypes;
        case 'widget':
          return this.widgetTypes;
        case 'renderer':
          return this.rendererTypes;
        case 'display':
          return this.displayTypes;
        case 'track':
          return this.trackTypes;
        case 'view':
          return this.viewTypes;
        case 'rpc method':
          return this.rpcMethods;
        case 'internet account':
          return this.internetAccountTypes;
        case 'add track workflow':
          return this.addTrackWidgets;
        default:
          throw new Error("invalid element type '".concat(groupName, "'"));
      }
    }
  }, {
    key: "addElementType",
    value: function addElementType(groupName, creationCallback) {
      var _this4 = this;
      var _a;
      if (typeof creationCallback !== 'function') {
        throw new Error('must provide a callback function that returns the new type object');
      }
      var typeRecord = this.getElementTypeRecord(groupName);
      (_a = this.elementCreationSchedule) === null || _a === void 0 ? void 0 : _a.add(groupName, function () {
        var newElement = creationCallback(_this4);
        if (!newElement.name) {
          throw new Error("cannot add a ".concat(groupName, " with no name"));
        }
        if (typeRecord.has(newElement.name)) {
          throw new Error("".concat(groupName, " ").concat(newElement.name, " already registered, cannot register it again"));
        }
        typeRecord.add(newElement.name, _this4.evaluateExtensionPoint('Core-extendPluggableElement', newElement));
      });
      return this;
    }
  }, {
    key: "getElementType",
    value: function getElementType(groupName, typeName) {
      return this.getElementTypeRecord(groupName).get(typeName);
    }
  }, {
    key: "getElementTypesInGroup",
    value: function getElementTypesInGroup(groupName) {
      return this.getElementTypeRecord(groupName).all();
    }
  }, {
    key: "getTrackElements",
    value: function getTrackElements() {
      return this.getElementTypesInGroup('track');
    }
  }, {
    key: "getAddTrackWorkflowElements",
    value: function getAddTrackWorkflowElements() {
      return this.getElementTypesInGroup('add track workflow');
    }
  }, {
    key: "getRpcElements",
    value: function getRpcElements() {
      return this.getElementTypesInGroup('rpc method');
    }
  }, {
    key: "getDisplayElements",
    value: function getDisplayElements() {
      return this.getElementTypesInGroup('display');
    }
  }, {
    key: "getAdapterElements",
    value: function getAdapterElements() {
      return this.getElementTypesInGroup('adapter');
    } /** get a MST type for the union of all specified pluggable MST types */
  }, {
    key: "pluggableMstType",
    value: function pluggableMstType(groupName, fieldName) {
      var _mobx_state_tree_1$ty;
      var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : mobx_state_tree_1.types.maybe(mobx_state_tree_1.types.null);
      var pluggableTypes = this.getElementTypeRecord(groupName).all()
      // @ts-ignore
      .map(function (t) {
        return t[fieldName];
      }).filter(function (t) {
        return (0, mobx_state_tree_1.isType)(t) && (0, mobx_state_tree_1.isModelType)(t);
      });
      // try to smooth over the case when no types are registered, mostly
      // encountered in tests
      if (pluggableTypes.length === 0 && typeof jest === 'undefined') {
        console.warn("No pluggable types found matching ('".concat(groupName, "','").concat(fieldName, "')"));
        return fallback;
      }
      return (_mobx_state_tree_1$ty = mobx_state_tree_1.types).union.apply(_mobx_state_tree_1$ty, _toConsumableArray(pluggableTypes));
    } /** get a MST type for the union of all specified pluggable config schemas */
  }, {
    key: "pluggableConfigSchemaType",
    value: function pluggableConfigSchemaType(typeGroup) {
      var _mobx_state_tree_1$ty2;
      var fieldName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'configSchema';
      var pluggableTypes = this.getElementTypeRecord(typeGroup).all()
      // @ts-ignore
      .map(function (t) {
        return t[fieldName];
      }).filter(function (t) {
        return (0, configuration_1.isBareConfigurationSchemaType)(t);
      });
      if (pluggableTypes.length === 0) {
        pluggableTypes.push((0, configuration_1.ConfigurationSchema)('Null', {}));
      }
      return (_mobx_state_tree_1$ty2 = mobx_state_tree_1.types).union.apply(_mobx_state_tree_1$ty2, _toConsumableArray(pluggableTypes));
    }
  }, {
    key: "getRendererType",
    value: function getRendererType(typeName) {
      return this.rendererTypes.get(typeName);
    }
  }, {
    key: "getRendererTypes",
    value: function getRendererTypes() {
      return this.rendererTypes.all();
    }
  }, {
    key: "getAdapterType",
    value: function getAdapterType(typeName) {
      return this.adapterTypes.get(typeName);
    }
  }, {
    key: "getTextSearchAdapterType",
    value: function getTextSearchAdapterType(typeName) {
      return this.textSearchAdapterTypes.get(typeName);
    }
  }, {
    key: "getTrackType",
    value: function getTrackType(typeName) {
      return this.trackTypes.get(typeName);
    }
  }, {
    key: "getDisplayType",
    value: function getDisplayType(typeName) {
      return this.displayTypes.get(typeName);
    }
  }, {
    key: "getViewType",
    value: function getViewType(typeName) {
      return this.viewTypes.get(typeName);
    }
  }, {
    key: "getAddTrackWorkflow",
    value: function getAddTrackWorkflow(typeName) {
      return this.addTrackWidgets.get(typeName);
    }
  }, {
    key: "getWidgetType",
    value: function getWidgetType(typeName) {
      return this.widgetTypes.get(typeName);
    }
  }, {
    key: "getConnectionType",
    value: function getConnectionType(typeName) {
      return this.connectionTypes.get(typeName);
    }
  }, {
    key: "getRpcMethodType",
    value: function getRpcMethodType(methodName) {
      return this.rpcMethods.get(methodName);
    }
  }, {
    key: "getInternetAccountType",
    value: function getInternetAccountType(name) {
      return this.internetAccountTypes.get(name);
    }
  }, {
    key: "addRendererType",
    value: function addRendererType(cb) {
      return this.addElementType('renderer', cb);
    }
  }, {
    key: "addAdapterType",
    value: function addAdapterType(cb) {
      return this.addElementType('adapter', cb);
    }
  }, {
    key: "addTextSearchAdapterType",
    value: function addTextSearchAdapterType(cb) {
      return this.addElementType('text search adapter', cb);
    }
  }, {
    key: "addTrackType",
    value: function addTrackType(cb) {
      var _this5 = this;
      // Goes through the already-created displays and registers the ones that
      // specify this track type
      var callback = function callback() {
        var track = cb(_this5);
        var displays = _this5.getElementTypesInGroup('display');
        displays.forEach(function (display) {
          // track may have already added the displayType in its cb
          if (display.trackType === track.name && !track.displayTypes.includes(display)) {
            track.addDisplayType(display);
          }
        });
        return track;
      };
      return this.addElementType('track', callback);
    }
  }, {
    key: "addDisplayType",
    value: function addDisplayType(cb) {
      return this.addElementType('display', cb);
    }
  }, {
    key: "addViewType",
    value: function addViewType(cb) {
      var _this6 = this;
      var callback = function callback() {
        var newView = cb(_this6);
        var displays = _this6.getElementTypesInGroup('display');
        displays.forEach(function (display) {
          // view may have already added the displayType in its callback
          // see ViewType for description of extendedName
          if ((display.viewType === newView.name || display.viewType === newView.extendedName) && !newView.displayTypes.includes(display)) {
            newView.addDisplayType(display);
          }
        });
        return newView;
      };
      return this.addElementType('view', callback);
    }
  }, {
    key: "addWidgetType",
    value: function addWidgetType(cb) {
      return this.addElementType('widget', cb);
    }
  }, {
    key: "addConnectionType",
    value: function addConnectionType(cb) {
      return this.addElementType('connection', cb);
    }
  }, {
    key: "addRpcMethod",
    value: function addRpcMethod(cb) {
      return this.addElementType('rpc method', cb);
    }
  }, {
    key: "addInternetAccountType",
    value: function addInternetAccountType(cb) {
      return this.addElementType('internet account', cb);
    }
  }, {
    key: "addAddTrackWorkflowType",
    value: function addAddTrackWorkflowType(cb) {
      return this.addElementType('add track workflow', cb);
    }
  }, {
    key: "addToExtensionPoint",
    value: function addToExtensionPoint(extensionPointName, callback) {
      var callbacks = this.extensionPoints.get(extensionPointName);
      if (!callbacks) {
        callbacks = [];
        this.extensionPoints.set(extensionPointName, callbacks);
      }
      callbacks.push(callback);
    }
  }, {
    key: "evaluateExtensionPoint",
    value: function evaluateExtensionPoint(extensionPointName, extendee, props) {
      var callbacks = this.extensionPoints.get(extensionPointName);
      var accumulator = extendee;
      if (callbacks) {
        var _iterator = _createForOfIteratorHelper(callbacks),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var callback = _step.value;
            try {
              accumulator = callback(accumulator, props);
            } catch (error) {
              console.error(error);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      return accumulator;
    }
  }, {
    key: "evaluateAsyncExtensionPoint",
    value: function () {
      var _evaluateAsyncExtensionPoint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(extensionPointName, extendee, props) {
        var callbacks, accumulator, _iterator2, _step2, callback;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              callbacks = this.extensionPoints.get(extensionPointName);
              accumulator = extendee;
              if (!callbacks) {
                _context.next = 27;
                break;
              }
              _iterator2 = _createForOfIteratorHelper(callbacks);
              _context.prev = 4;
              _iterator2.s();
            case 6:
              if ((_step2 = _iterator2.n()).done) {
                _context.next = 19;
                break;
              }
              callback = _step2.value;
              _context.prev = 8;
              _context.next = 11;
              return callback(accumulator, props);
            case 11:
              accumulator = _context.sent;
              _context.next = 17;
              break;
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](8);
              console.error(_context.t0);
            case 17:
              _context.next = 6;
              break;
            case 19:
              _context.next = 24;
              break;
            case 21:
              _context.prev = 21;
              _context.t1 = _context["catch"](4);
              _iterator2.e(_context.t1);
            case 24:
              _context.prev = 24;
              _iterator2.f();
              return _context.finish(24);
            case 27:
              return _context.abrupt("return", accumulator);
            case 28:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[4, 21, 24, 27], [8, 14]]);
      }));
      function evaluateAsyncExtensionPoint(_x, _x2, _x3) {
        return _evaluateAsyncExtensionPoint.apply(this, arguments);
      }
      return evaluateAsyncExtensionPoint;
    }()
  }]);
  return PluginManager;
}();
exports.default = PluginManager;